<div class="layout-date-container scrollable-component-container">
  <div
    class="attribute-editor-component scrollable-component-settings te-scrollable-container"
  >
    <div class="attribute-editor-row">
      <!-- Layout Selection -->
      <div class="form-group layout-selector">
        <label class="control-label" id="layout-selection-label"
          >Choose Layout</label
        >
        <div
          class="layout-container"
          role="radiogroup"
          aria-labelledby="layout-selection-label"
        >
          <button
            type="button"
            class="layout-option"
            [ngClass]="{
              'layout-option--selected': layout === LayoutType.INLINE,
            }"
            (click)="setLayout(LayoutType.INLINE)"
            (keydown)="onLayoutKeydown($event, LayoutType.INLINE)"
            [attr.aria-checked]="layout === LayoutType.INLINE"
            [attr.tabindex]="layout === LayoutType.INLINE ? '0' : '-1'"
            role="radio"
          >
            <div class="layout-icon-container layout-inline">January 1</div>
            <div class="layout-label">Inline</div>
          </button>
          <button
            type="button"
            class="layout-option"
            [ngClass]="{
              'layout-option--selected': layout === LayoutType.STACKED,
            }"
            (click)="setLayout(LayoutType.STACKED)"
            (keydown)="onLayoutKeydown($event, LayoutType.STACKED)"
            [attr.aria-checked]="layout === LayoutType.STACKED"
            [attr.tabindex]="layout === LayoutType.STACKED ? '0' : '-1'"
            role="radio"
          >
            <div class="layout-icon-container layout-stacked">
              <div class="day-number">01</div>
              <div class="month-name">JANUARY</div>
            </div>
            <div class="layout-label">Stacked</div>
          </button>
          <button
            *requireRole="AI_LAYOUT_ROLE"
            type="button"
            class="layout-option"
            [ngClass]="{
              'layout-option--selected': isCustomLayout,
            }"
            (click)="openLayoutAi()"
            [attr.aria-checked]="isCustomLayout"
            role="radio"
          >
            <div class="layout-icon-container">
              <mat-icon svgIcon="ai-gradient" aria-hidden="true"></mat-icon>
            </div>
            <div class="layout-label">AI layout</div>
          </button>
        </div>
        <layout-ai-edit-button
          *requireRole="AI_LAYOUT_ROLE"
          id="te-ld-edit-layout"
          [shown]="isCustomLayout"
          (edit)="editLayoutAi()"
        ></layout-ai-edit-button>
      </div>
    </div>

    <div class="attribute-editor-row">
      <div class="form-group">
        <label>Time Zone</label>
        <select
          id="te-ld-timezone"
          class="form-control"
          [(ngModel)]="timezone"
          (change)="save()"
        >
          <option value="">Display's Time Zone (Default)</option>
          @for (tz of WORLD_TIMEZONES; track tz) {
            <option [value]="tz">{{ tz }}</option>
          }
        </select>
      </div>
    </div>

    <div
      class="attribute-editor-row"
      [shown]="
        isCustomLayout
          ? usesAttribute('dateFormat')
          : layout === LayoutType.INLINE
      "
    >
      <!-- Date Format Selection -->

      <div class="form-group">
        <label for="te-td-date-format">Date Format</label>
        <select
          id="te-td-date-format"
          class="form-control"
          name="dateFormatSelect"
          [(ngModel)]="dateFormat"
          (change)="save()"
        >
          @for (df of dateFormats; track df) {
            <option [value]="df.format">{{ df.date }}</option>
          }
        </select>
      </div>
    </div>

    <div class="attribute-editor-row" [shown]="usesAttribute('color')">
      <!-- Color Picker -->
      <div class="form-group">
        <label>Color</label>
        <div class="flex-row left-right-aligner">
          <color-picker
            pickerId="te-ld-color"
            [(ngModel)]="color"
            (change)="save()"
            ngDefaultControl
          ></color-picker>
        </div>
      </div>
    </div>
  </div>
</div>
